import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { BlankOverlay } from "../Fx/BlankOverlay";
import { ShareButtonGenocide } from "../elements/ShareButtonGenocide";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  guesses: string[];
  todayTS: number;
  title: string;
};

export const GenocideModal = ({ isOpen, handleClose, guesses, todayTS, title }: Props) => {
  let closeButtonRef = useRef(null);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed top-0 z-10 inset-0 overflow-y-auto"
        onClose={()=>{}}
        initialFocus={closeButtonRef}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-95 transition-opacity" />
          </Transition.Child>

          <BlankOverlay isOpen={true} />

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div id="my-modal-card" className="inline-block align-bottom bg-white dark:bg-gray-900 text-gray-900 dark:text-white rounded-lg px-4 pt-8 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full">
              <button className="focus:outline-dashed outline-1 outline-blue-500 absolute right-2 top-2 cursor-pointer"
                onClick={handleClose}>
                <XIcon className="h-6 w-6 text-blue-600 dark:text-blue-500" />
              </button>

              <div className="mt-4 text-center sm:mt-5">
                <Dialog.Title
                  as="h3"
                  className="text-2xl leading-6 font-black tracking-widest"
                >
                  {title}
                </Dialog.Title>
              </div>

              <div className="mt-5 sm:mt-6 px-1 text-lg text-center text-balance">
                <p><span className="font-bold">“Basta”</span> è la sola parola di cinque lettere che qui voglio avere.</p>
                <p>Che serva o meno.</p>
                <p className="mt-4">Non ci sarà una prossima paroletta, non ci sarà una prossima volta.</p>
                <p className="mt-4">State bene, xho. 🖖🏻</p>
              </div>

              <div className="mt-5 flex space-x-2 justify-center text-xl">
                <span>🟥</span>
                <span>⬛</span>
                <span>⬜</span>
                <span>🟩</span>
              </div>

              <div className="mt-8 sm:mt-6">
                <ShareButtonGenocide guesses={guesses} title={title} success={true} />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
